import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
]

export default function SelectMinStay({...props}) {
    const myProps = {
        placeholder: 'Min stay?',
        firstSelect: true, 
        isClearable: true, 
        options: OPTIONS,
        icon: {icon: 'user-minus'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}